module DdsOfficePicker {
  let stateSelect: JQuery<HTMLElement>;
  let citySelect: JQuery<HTMLElement>;
  let officesSelect: JQuery<HTMLElement>;

  export function construct() {
    stateSelect = $("#DdsOfficeStateSelect");
    citySelect = $("#DdsOfficeCitySelect");
    officesSelect = $("#DdsOfficesSelect");

    stateSelect.change(stateSelectChanged);
    citySelect.change(citySelectChanged);

    if (stateSelect.length > 0) {
      stateSelectChanged();
    }
  }

  function stateSelectChanged() {
    clearOfficeCitySelect();
    clearOfficeSelect();
    SelectTools.addBlankOption(citySelect);

    const state = selectedState();
    DdsOfficeFactory.GetCitiesByState(state,
      (cities: string[]) => {
        $.each(cities, (index, city) => {
          citySelect.append(`<option>${city}</option>`);
        });
      },
      () => {
        Notifications.Warning(`Failed to retrieve list of cities with Dds Offices for the state ${state}.`);
      }
    );
  }

  function citySelectChanged() {
    clearOfficeSelect();
    SelectTools.addBlankOption(officesSelect);

    const state = selectedState();
    const city = selectedCity();
    DdsOfficeFactory.GetDdsOfficesByStateCity(state, city,
      (ddsOffices) => {
        $.each(ddsOffices, (index, ddsOffice) => {
          officesSelect.append(`<option value="${ddsOffice.RowID}">${ddsOffice.Address}</option>`);
        });
      },
      () => {
        Notifications.Warning(`Failed to retrieve list of Dds Offices for ${city}, ${state}.`);
      }
    );
  }

  const selectedState = () => stateSelect.val() as States;
  const selectedCity = () => citySelect.val() as string;

  const clearOfficeCitySelect = () => citySelect.html("");
  const clearOfficeSelect = () => officesSelect.html("");
}